import React from 'react';
import { makeStyles } from '@material-ui/core';
import KapinuaColors from '../KapinuaColors/KapinuaColors';
import { Box, Grid, Skeleton, useMediaQuery } from '@mui/material';
import theme from '../../themes/GlobalTheme';

const useStyles = makeStyles(() => ({
    dialogItem: {
        float: 'left',
    },
    break: {
        clear: 'both',
        width: '100%',
    },
    color: {
        width: '30px',
        height: '30px',
        borderRadius: '50%',
        boxShadow: '0 0 3px 1px #000',
        marginBottom: '10px',
        marginRight: 'auto',
        marginLeft: 'auto',
    },
}));

interface Props {
    onChange: (oldColor: string, newColor: string) => void;
    colors: string[];
    loading: boolean;
}
const ColorList: React.FC<Props> = (props) => {
    const classes = useStyles();
    const isSmUp = useMediaQuery(theme.breakpoints.up('sm'));

    const { colors, onChange, loading } = props;
    const [isOpen, setIsOpen] = React.useState<boolean>(false);
    const [activeColor, setActiveColor] = React.useState<string | null>(null);

    const handleOnClick = (color: string) => {
        setIsOpen(true);
        setActiveColor(color);
    };

    const handleOnChange = (color: string) => {
        if (activeColor) {
            onChange(activeColor, color);
        }
        setActiveColor(null);
    };

    return (
        <>
            <KapinuaColors
                open={isOpen}
                onClose={() => setIsOpen(false)}
                onChange={handleOnChange}
            />
            <Grid
                container
                justifyContent="center"
                alignItems="center"
                direction={'row'}
            >
                {loading &&
                    Array.from(new Array(4)).map((item, index) => (
                        <Grid item xs={isSmUp ? 12 : 1.5} key={index}>
                            <Skeleton
                                className={classes.color}
                                variant="circular"
                                width={30}
                                height={30}
                            />
                        </Grid>
                    ))}
                {colors &&
                    colors.map((color, index) => {
                        return (
                            <Grid
                                item
                                xs={
                                    isSmUp ? (colors.length > 10 ? 6 : 12) : 1.5
                                }
                                key={index}
                            >
                                <Box
                                    className={classes.color}
                                    style={{ background: color }}
                                    onClick={() => handleOnClick(color)}
                                />
                            </Grid>
                        );
                    })}
            </Grid>
        </>
    );
};

export default ColorList;
